import { isEmpty } from 'lodash-es';
import React from 'react';

import { ITargetingPreset, TargetingPresetKey } from '~/src/dash/apiV2/targeting/targetingPresets';
import { ILocalTargetingParsed } from '~/src/dash/components/forms/formBuilder/ParameterRow/editors/LocalTargetingBuilder/common';
import { disableSelectTextStyle } from '~/src/dash/components/text/common';
import { borderRadius, fontSizing, spacing, Text } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';
import { ELogicalOperator } from '~/src/dash/utils/options';
import { TargetingPresetParamKey } from '~/src/dash/views/tools/TargetingPresets/TargetingPresetFormView/config';
import { useTargetingSummaryTableStore } from '~/src/dash/views/tools/TargetingPresets/TargetingPresetFormView/TargetingSummaryTable/context';

const ltKeys: (keyof ILocalTargetingParsed)[] = ['country', 'states', 'cities', 'dmas', 'zips'];

interface Countries {
  id: string;
  label: string;
}

const convertToString = (localTargeting: ILocalTargetingParsed[]) => {
  const { lists } = useTargetingSummaryTableStore();
  const countryList: Countries[] = lists.Countries;
  if (!localTargeting || isEmpty(localTargeting)) return [];
  const result: string[] = [];
  localTargeting.forEach((lt) => {
    const strings: string[] = [];
    ltKeys.forEach((key) => {
      if (lt[key]) {
        if (key === 'country') {
          (lt[key] as string).split(',').forEach((s) => {
            const countryName = countryList.find((ele) => ele.id === s);
            if (countryName) {
              strings.push(countryName.label);
            }
          });
        } else {
          (lt[key] as string).split(',').forEach((s) => strings.push(s));
        }
      }
    });
    result.push(strings.join(', '));
  });
  return result;
};

export interface ILocalTargetingSummaryProps {
  preset: ITargetingPreset;
  valueKey: TargetingPresetKey;
  logicKey: TargetingPresetKey;
  paramKey: TargetingPresetParamKey;
}

export const LocalTargetingSummary = ({
  preset,
  valueKey,
  logicKey,
}: ILocalTargetingSummaryProps) => {
  const parsedValue = !!preset[valueKey]
    ? // @ts-ignore
      JSON.parse(preset[valueKey])
    : ([] as ILocalTargetingParsed[]);
  const value = convertToString(parsedValue);
  const isOrLogic = preset[logicKey] !== ELogicalOperator.AND;

  return (
    <div>
      {value && !isEmpty(value) && (
        <Text
          bold
          style={{
            verticalAlign: 'middle',
            fontSize: fontSizing.extraSmall,
            paddingRight: spacing.extraSmall,
          }}
        >
          <div
            style={{
              display: 'inline',
              verticalAlign: 'middle',
              backgroundColor: isOrLogic ? publicaColors.ivory : publicaColors.lavender,
              border: `1px solid ${publicaColors.lightGray}`,
              borderRadius: borderRadius.small,
              padding: `2px ${spacing.small}`,
              ...disableSelectTextStyle,
            }}
          >
            {isOrLogic ? 'OR' : 'AND'}
          </div>
        </Text>
      )}
      {value.map((v) => {
        if (v.length > 164) {
          return <Text small>{`• ${v.substring(0, 164)}...`}</Text>;
        }
        return <Text small>{`• ${v}`}</Text>;
      })}
    </div>
  );
};
